import { Component,HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { CommonEventService } from '../services/common-event.service';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../footer/footer.component';
// import { from } from 'rxjs';
// declare var require: any
// const { v4: uuidv4 } = require('uuid');

@Component({
    selector: 'app-assembly-process',
    templateUrl: './assembly-process.component.html',
    styleUrls: ['./assembly-process.component.css'],
    imports: [FooterComponent, FormsModule,ReactiveFormsModule, CommonModule],
    standalone: true
})
export class AssemblyProcessComponent {
  priceMatrixSec : boolean = true;
  addAssembly:boolean = false;
  bomUploadSec:boolean = false;
  autoMapping:boolean = false;
  closeResult: string = '';
  autoMappingData:any;
  sidesToAssemble:any;
  isHidden = true;
  mainRowArrayObj:any = {
    'labelsArray' : [],
    'bomOneMapArrayData' : []
  };
  qtyIndvBoardsArray : any = [];
  priceMatrixData : any;
  uploadedFile: any = {};
  assemblyInfo: any = {};
  selectedFabPrice:any;
  finalQuotedataObj:any ={};
  selectedFabTurntimeVal :any;
  assemblyQuoteJson = [];
  curentAssemblyFileUploadedName :any;
  missingFiles:any = [];
  missingListFiles :any =[];
  disableAssemblyErrorProceed:boolean = false;
  IsAllowedFileExtension : boolean = true;
  showNumberOfSheets : boolean = false;
  selectedSheetNum:any;
  sheetsArray :any =[];
  bomFileData :any;
  disableAutomapProceed : boolean = false;
  assemblyProcesstooltips =[
    {name:'1', value: "'Lead free processing' must be set to 'No' when Surface finish is 'HASL' "},
    {name:'2', value: "'Lead free processing' must be set to 'Yes' when Surface finish is 'ENIG' "}
  ];
  checkBomAutoUploaded:any;
  checkBomAdded:boolean = false;
  mappingDateTime:any;
  mappingArray:any=[];
  selectedColMapValList:any=[];
  mapValueArray:any=[];
  bomMappingKeyObj:any={};
  bomChanged:boolean = false;
  flowActivityId:any='';
  pcbFabtooltips = [
    {name:'1',value:'<b>Get Assembly Quote </b>: Quoting Assembly is Convenient and Cost-Effective <br>By quoting assembly labor along with PCB Fabrication, you don\'t have to deal with a separate fab and assembly vendor. Get a single point of support for your complete project.'},
    {name:'2', value:'<b>Number of sides to be assembled </b>: Is assembly required on one side or both sides of the board?'},
    {name:'3',value:'<b>Lead-free processing </b>: Should the board be manufactured by eliminating lead from all components?'},
    {name:'4', value:'<b>Quantity of assembled boards </b>: Number of boards to be assembled.'}
  ];
  extractedAssemblySide:any='';
  pricingDetailsEventObj:any={};
  bomAutoMapScreenRendered:boolean=false;
  numOfSidesImg:any='';
  leadFreeImg:any='';
  // viaInPadImg:any='';
  socketDataLoadingCheck : boolean = false;
  modalName:any='';
  // uID = uuidv4();;
  constructor(
    private router: Router,
    public apiService:ApiService,
    private modalService: NgbModal,
    public commonService : CommonEventService
  ){
    
  }
  
  ngOnInit(): void {
    // $('#dynamicIframe').attr('src', '');
    // $('#iframeContainer').hide();
    this.commonService.loadingHide();
    // window.onbeforeunload = function () {
      this.commonService.formattingCurrentDateTime();
      setTimeout(()=>{
        window.scrollTo(0, 0);
      },300);
      var pcbPricingInitData={
        "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
      }
      this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
      this.apiService.updateDetailsToDashboard(this.flowActivityId,pcbPricingInitData,'PCBFabPricingPage').subscribe((resDatas)=>{
      // console.log("updateDetailsToDashboard",resDatails);
      })
      this.commonService.restrictBrowserButtons();
      this.commonService.restrictRefreshButton();
    // }
  
    if(this.commonService.commonMainObj.fileUploadedData.uploadedBOM && Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM).length >0 ){
      this.commonService.commonMainObj.autoUploadFileName = Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0];
      this.commonService.commonMainObj.autoUploadFileId = Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0]
    }

    this.checkBomAutoUploaded = this.commonService.commonMainObj.autoUploadFileName;
    // Assembly quote matrix data creation
    // var preUploadFileName:any = Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0]
    // $('#assembly_bom_file_upload').val(preUploadFileName);
    if(this.commonService.commonMainObj.autoUploadFileName){
      $('#assemblyYes').trigger('click');
    }
    this.commonService.commonMainObj.qtyAssemblies = '';
    //OFP-3120
    this.numOfSidesImg = this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.assembly_sides != '' ? "Extracted_icon":"Default_icon";
    if(this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'RoHS/Lead Free' || this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'Leaded'){
      this.leadFreeImg = (this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'ENIG' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'RoHS/Lead Free') || (this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'HASL' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'Leaded') ? "Extracted_icon":"Default_icon";
      //OFP-3209
      this.commonService.commonMainObj.additionalTextHasl = false;
      this.commonService.commonMainObj.additionalTextEnig = false;
      $('#additionalTextEnig').html('');
      $('#additionalTextHasl').html('');
      if(this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'HASL' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'RoHS/Lead Free'){
        this.commonService.commonMainObj.additionalTextHasl=true;
        this.commonService.commonMainObj.leadfreeHasl = "'Lead-free Processing' should be set to 'No' when Surface Finish is 'HASL'.";
      }else if(this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'ENIG' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'Leaded'){
        this.commonService.commonMainObj.additionalTextEnig=true;
        this.commonService.commonMainObj.leadedEnig = "'Lead-free Processing' should be set to 'Yes' when Surface Finish is 'ENIG'.";
      }
    }else{
      this.leadFreeImg = "Default_icon";
      this.commonService.commonMainObj.additionalTextHasl = false;
      this.commonService.commonMainObj.additionalTextEnig = false;
      $('#additionalTextEnig').html('');
      $('#additionalTextHasl').html('');
    }
    // this.viaInPadImg = "Default_icon";
    //OFP-2758
    this.extractedAssemblySide = this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.assembly_sides != '' ? this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.assembly_sides == '1 side' ? '1 side' : '2 side' : '1 side';
    if(this.extractedAssemblySide == '1 side'){
      $('#numberOfSidesOne').addClass('active');
      $('#numberOfSidesOne').addClass('btn-green');
      $('#numberOfSidesOne').removeClass('btn-gray');
      $('#numberOfSidesTwo').removeClass('btn-green');
      $('#numberOfSidesTwo').addClass('btn-gray');
      $('#numberOfSidesTwo').removeClass('active');
    }else if(this.extractedAssemblySide == '2 side'){
      $('#numberOfSidesTwo').addClass('active');
      $('#numberOfSidesTwo').addClass('btn-green');
      $('#numberOfSidesTwo').removeClass('btn-gray');
      $('#numberOfSidesOne').removeClass('btn-green');
      $('#numberOfSidesOne').addClass('btn-gray');
      $('#numberOfSidesOne').removeClass('active');
    }
    if(this.bomUploadSec){
      setTimeout(() => {
        if(this.commonService.commonMainObj.boardDetailsDataObj.thruHoleViainPad == 'Yes'){
          this.viaInPadSelectedYes();
        }else{
          this.viaInPadSelectedNo();
        }
      }, 1000);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent) {
      const perfEntries :any = performance.getEntriesByType("navigation");
      this.commonService.formattingCurrentDateTime();
      if (perfEntries.length > 0 && perfEntries[0].type === "reload") {
        console.log("Page was refreshed");
      }else{
        console.log("Likely tab close");
        this.pricingDetailsEventObj ={
          sourceApp : "oneflow",
          eventType: this.bomAutoMapScreenRendered ? 'BomValidation': 'PCBPrice',
          emailAddress: this.commonService.commonMainObj.boardDetailsDataObj.email ? this.commonService.commonMainObj.boardDetailsDataObj.email:'',
          triggerDate:this.commonService.commonMainObj.formattedDate +'-'+this.commonService.commonMainObj.capturedEventTime,
          createdAt:this.commonService.commonMainObj.capturedEventCreatedAt,
        }
        const blobEventObj = new Blob([JSON.stringify(this.pricingDetailsEventObj)], {
          type: 'application/json'
        });
        if(!this.commonService.commonMainObj.logoClicked){
          this.apiService.callAPIToSendCapturedEvent(blobEventObj);
        }
      }
        // // OFP-2560 dashboard
        this.apiService.updateSessionTimeSpent(this.flowActivityId,'PCBFabPricingPage');
        console.log("checkk");
      //  event.preventDefault();
      //  event.returnValue = false;
      
    }

  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }

  gotoAssembly(){
    // this.router.navigateByUrl('/bomAssemblyProcess');
    this.router.navigateByUrl('/bomPreProcess');
  }

  assemblyYesCheck(){
    if(this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'ENIG'){
      $('#LeadFreeNo').removeClass('btn-green');
      $('#LeadFreeNo').addClass('btn-gray');
      $('#leadFreeYes').addClass('btn-green');
      $('#leadFreeYes').removeClass('btn-gray');
      $('#LeadFreeNo').removeClass('active');
      $('#leadFreeYes').addClass('active');
      $('#LeadFreeNo').prop("disabled",true);
      $('#leadFreeYes').prop("disabled",false);
      $('#leadFreeProcess-1').hide();
      $('#leadFreeProcess-2').show();
    }
    if(this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'HASL'){
      $('#LeadFreeNo').addClass('btn-green');
      $('#LeadFreeNo').removeClass('btn-gray');
      $('#LeadFreeNo').addClass('active');
      $('#leadFreeYes').removeClass('btn-green');
      $('#leadFreeYes').addClass('btn-gray');  
      $('#leadFreeYes').removeClass('active');
      $('#leadFreeYes').prop("disabled",true);
      $('#LeadFreeNo').prop("disabled",false);
      $('#leadFreeProcess-1').show();
      $('#leadFreeProcess-2').hide();

    }
    //changes related to https://protoexpress.atlassian.net/browse/OFP-2819
    if(this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'Immersion Silver' && this.commonService.commonMainObj.pcbType == 'Web PCB'){
      $('#leadFreeYes').prop("disabled",false);
      $('#LeadFreeNo').prop("disabled",false);
      $('#leadFreeProcess-2').hide();
      $('#leadFreeProcess-1').hide();
      if(this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'RoHS/Lead Free'){
        $('#LeadFreeNo').removeClass('btn-green');
        $('#LeadFreeNo').addClass('btn-gray');
        $('#leadFreeYes').addClass('btn-green');
        $('#leadFreeYes').removeClass('btn-gray');
        $('#LeadFreeNo').removeClass('active');
        $('#leadFreeYes').addClass('active');
      }else{
        $('#leadFreeYes').removeClass('btn-green');
        $('#leadFreeYes').addClass('btn-gray');
        $('#LeadFreeNo').addClass('btn-green');
        $('#LeadFreeNo').removeClass('btn-gray');
        $('#leadFreeYes').removeClass('active');
        $('#LeadFreeNo').addClass('active');
      }

      
    }
    $('#assemblyNo').removeClass('btn-green');
    $('#assemblyNo').addClass('btn-gray');
    $('#assemblyYes').addClass('btn-green');
    $('#assemblyYes').removeClass('btn-gray');
    $('#assemblyNo').removeClass('active');
    $('#assemblyYes').addClass('active');
    this.bomUploadSec = true;
    $('#uploadBomSec').show();
    if(this.commonService.commonMainObj.itar == "Yes" ){
      $('#itarRadioButtonGroup').css('display','none');
      $('#itarSwitchButtonGroup').css('display','block');
      $('#itarYes').addClass('btn-green');
      $('#itarYes').addClass('active');
      $('#itarYes').removeClass('btn-gray');
      $('#itarNo').removeClass('btn-green');
      $('#itarNo').addClass('btn-gray');
      $('#itarNo').removeClass('active');
    }else if(this.commonService.commonMainObj.itar == "Yes" ){
      $('#itarRadioButtonGroup').css('display','block');
      $('#itarSwitchButtonGroup').css('display','none');
    }
    // if(this.selectedFabTurntimeVal < 5){
    //   $('#viaInPadsYes').prop("disabled",true);
    // }else{
    //   $('#viaInPadsYes').prop("disabled",false);
    // }
    if(this.commonService.commonMainObj.boardDetailsDataObj.thruHoleViainPad == 'Yes'){
      this.viaInPadSelectedYes();
      if(this.selectedFabTurntimeVal < 5 && this.commonService.commonMainObj.pcbType == 'Web PCB'){
        $('.select-price').prop('checked', false);
        Swal.fire({
            title: "Alert!!",
            html: 'You have chosen a PCB fabrication time of '+ this.selectedFabTurntimeVal +'days.In order to fill your via-in-pads with non-conductive fill, we will need PCB fabrication cycle of 5 days or more. Kindly choose a turn time for 5 days or more in the PCB price matrix. <br>If you want to change the value of PCB has Via-in-pad features?, please click on ‘Back’ button and change the value on the ‘Board Details’ page',
            width: '35em'
        });
        return;
      }
    }else{
      this.viaInPadSelectedNo();
    }
  }
  viaInPadSelectedYes(){
    $('#viaInPadsYes').addClass('btn-green');
    $('#viaInPadsYes').addClass('active');
    $('#viaInPadsYes').removeClass('btn-gray');
    $('#viaInPadsNo').removeClass('btn-green');
    $('#viaInPadsNo').addClass('btn-gray');
    $('#viaInPadsNo').removeClass('active');
  }
  viaInPadSelectedNo(){
    $('#viaInPadsNo').addClass('btn-green');
    $('#viaInPadsNo').addClass('active');
    $('#viaInPadsNo').removeClass('btn-gray');
    $('#viaInPadsYes').removeClass('btn-green');
    $('#viaInPadsYes').removeClass('active');
    $('#viaInPadsYes').addClass('btn-gray');
  }
  switchOfButtons(event:any, content:any){
    var currentElement = event.target.id;
    //assembly checking
    if(currentElement == "assemblyYes"){
      if(Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length > 0){
        this.disableAssemblyErrorProceed = true;
        this.checkAssemblyErrorModal(content);
      }else{
        this.assemblyYesCheck();
      }
    }else if(currentElement == "assemblyNo"){
      $('#assemblyYes').removeClass('btn-green');
      $('#assemblyYes').addClass('btn-gray');
      $('#assemblyNo').addClass('btn-green');
      $('#assemblyNo').removeClass('btn-gray');
      $('#assemblyYes').removeClass('active');
      $('#assemblyNo').addClass('active');
      this.bomUploadSec = false;
      this.curentAssemblyFileUploadedName = '';
      $('#uploadBomSec').hide();
    }

    if(currentElement== 'itarYes'){
      this.commonService.commonMainObj.itar  = "Yes"
      $('#itarYes').addClass('btn-green');
      $('#itarYes').addClass('active');
      $('#itarYes').removeClass('btn-gray');
      $('#itarNo').removeClass('btn-green');
      $('#itarNo').addClass('btn-gray');
      $('#itarNo').removeClass('active');
    }else if(currentElement == 'itarNo'){
      this.commonService.commonMainObj.itar  = "No"
      $('#itarNo').addClass('btn-green');
      $('#itarNo').addClass('active');
      $('#itarNo').removeClass('btn-gray');
      $('#itarYes').removeClass('btn-green');
      $('#itarYes').removeClass('active');
      $('#itarYes').addClass('btn-gray');
    }
    if(currentElement== 'viaInPadsYes' || currentElement == 'viaInPadsNo'){
      this.commonService.alertCall('Alert!!','Please click on ‘Back’ button and change the value on the ‘Board Details’ page');
    }
    // if(currentElement== 'viaInPadsYes'){
    //   $('#viaInPadsYes').addClass('btn-green');
    //   $('#viaInPadsYes').addClass('active');
    //   $('#viaInPadsYes').removeClass('btn-gray');
    //   $('#viaInPadsNo').removeClass('btn-green');
    //   $('#viaInPadsNo').addClass('btn-gray');
    //   $('#viaInPadsNo').removeClass('active');
    // }else if(currentElement == 'viaInPadsNo'){
    //   $('#viaInPadsNo').addClass('btn-green');
    //   $('#viaInPadsNo').addClass('active');
    //   $('#viaInPadsNo').removeClass('btn-gray');
    //   $('#viaInPadsYes').removeClass('btn-green');
    //   $('#viaInPadsYes').removeClass('active');
    //   $('#viaInPadsYes').addClass('btn-gray');
    // }

    if(currentElement == "leadFreeYes"){
      $('#LeadFreeNo').removeClass('btn-green');
      $('#LeadFreeNo').addClass('btn-gray');
      $('#leadFreeYes').addClass('btn-green');
      $('#leadFreeYes').removeClass('btn-gray');
      $('#LeadFreeNo').removeClass('active');
      $('#leadFreeYes').addClass('active');
    }else if(currentElement == "LeadFreeNo"){
      $('#leadFreeYes').removeClass('btn-green');
      $('#leadFreeYes').addClass('btn-gray');
      $('#LeadFreeNo').addClass('btn-green');
      $('#LeadFreeNo').removeClass('btn-gray');
      $('#leadFreeYes').removeClass('active');
      $('#LeadFreeNo').addClass('active');
    }

    if(currentElement == "numberOfSidesOne"){
      $('#numberOfSidesTwo').removeClass('btn-green');
      $('#numberOfSidesTwo').addClass('btn-gray');
      $('#numberOfSidesOne').addClass('btn-green');
      $('#numberOfSidesOne').removeClass('btn-gray');
      $('#numberOfSidesTwo').removeClass('active');
      $('#numberOfSidesOne').addClass('active');
    }else if(currentElement == "numberOfSidesTwo"){
      $('#numberOfSidesOne').removeClass('btn-green');
      $('#numberOfSidesOne').addClass('btn-gray');
      $('#numberOfSidesTwo').addClass('btn-green');
      $('#numberOfSidesTwo').removeClass('btn-gray');
      $('#numberOfSidesOne').removeClass('active');
      $('#numberOfSidesTwo').addClass('active');
    }

    
    // OFP-3120
    if(currentElement == "numberOfSidesOne" || currentElement == "numberOfSidesTwo" ){
      if((this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.assembly_sides == '1 side' && currentElement == "numberOfSidesOne") || (this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.assembly_sides == '2 sides' && currentElement == "numberOfSidesTwo")){
      this.numOfSidesImg = 'Extracted_icon';
      }else if((this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.assembly_sides == '' && currentElement == "numberOfSidesOne")){
        this.numOfSidesImg = 'Default_icon';
      }
      else{
        this.numOfSidesImg = 'Updated_icon'
      }
    }
    if(currentElement == "leadFreeYes" || currentElement == "LeadFreeNo" ){
      if(this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish != 'ENIG' && this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish != 'HASL'){
        if((this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'RoHS/Lead Free' && currentElement == "leadFreeYes") || ((this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'Leaded' || this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance =='Others (Ex: hi-temp / low-temp)')  && currentElement == "LeadFreeNo") ){
        this.leadFreeImg = 'Extracted_icon';
        }else if((this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'RoHS/Lead Free' && currentElement == "LeadFreeNo") || ((this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'Leaded' || this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance =='Others (Ex: hi-temp / low-temp)')  && currentElement == "leadFreeYes") || (this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance != 'RoHS/Lead Free' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance != 'Leaded' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance !='Others (Ex: hi-temp / low-temp)' && currentElement == "leadFreeYes")){
          this.leadFreeImg = 'Updated_icon';
        }else if(this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance != 'RoHS/Lead Free' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance != 'Leaded' && this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance !='Others (Ex: hi-temp / low-temp)' && currentElement == "LeadFreeNo"){
          this.leadFreeImg = 'Default_icon';
        }
      }else if(this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'ENIG' || this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == 'HASL'){
        this.leadFreeImg = 'Default_icon';
      }
    }

    // if(currentElement== 'viaInPadsNo'){
    //   this.viaInPadImg = "Default_icon";
    // }else if(currentElement== 'viaInPadsYes'){
    //   this.viaInPadImg = "Updated_icon";
    // }
    
  }
  openViaInPad(content:any) {
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  uploadOtherBom(){
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
    }
    if(this.commonService.commonMainObj.autoUploadFileName){
      this.autoBomReplaceAlert();
    }else{
      $("#fileInputOther").trigger('click');
      $("#fileInputOther").val('');
    }
  }
  autoBomReplaceAlert(){
    this.commonService.bomConfirmAlert('The existing BOM in the initial files will be replaced with the new BOM. Are you sure you want to proceed with uploading a different BOM?').then((result:any) => {
      if (result.isConfirmed) {
        $("#fileInputOther").trigger('click');
        $("#fileInputOther").val('');
      } else if (result.isDismissed) {
        return false;
      }
    })
  }
  fileBrowseHandler(logs: any){
    const inputElement = logs.target;
    if (inputElement.files && inputElement.files.length > 0) {
      this.commonService.commonMainObj.uploadedFile = inputElement.files[0];
      this.curentAssemblyFileUploadedName = this.commonService.commonMainObj.uploadedFile.name;
      let fileExtension = this.curentAssemblyFileUploadedName.split('.').pop()?.toLowerCase();
      let allowedFileExtensions  = ['xls','xlsx'];
      if (fileExtension && allowedFileExtensions.includes(fileExtension)) {
        this.checkBomAdded = this.checkBomAutoUploaded != '' ? false:true;
        this.bomChanged = (this.checkBomAdded == false && this.commonService.commonMainObj.uploadedFile != '') ? true:false;
        this.commonService.commonMainObj.uploadedFileFullPath = inputElement.value;
        this.commonService.commonMainObj.autoUploadFileName = '';
        this.IsAllowedFileExtension = true;
        this.curentAssemblyFileUploadedName = this.commonService.commonMainObj.uploadedFile.name;
        this.commonService.commonMainObj.manuallyBomUploded = true;
        const file = inputElement.files[0];
        const reader = new FileReader();
        var convertedFile :any = [];
        reader.readAsDataURL(file);
        reader.onload = () => {
          convertedFile = reader.result;
          //console.log("Converted Uploaded FIle", convertedFile);
        };
        setTimeout(() => {
          if(convertedFile){
            this.commonService.commonMainObj.bomToBloobFile = convertedFile.toString().split('base64,')[1]
            //console.log("Converted Data", this.commonService.commonMainObj.bomToBloobFile);
          }
        }, 100);
      }else{
        this.IsAllowedFileExtension = false;
        this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
        return;
      }
    }
    //Below code is for manually uploded file converting into blod data to attach uploded file to zip
    
    //End
  }
  proceedAutoMapData(){
    this.commonService.sessionPortalLoad();
    if(this.disableAutomapProceed == true){
      this.commonService.showtoast('Please map all mandatory columns to proceed','warning');
      return false;
    }else{
      let itemNumberCheck = this.autoMappingData['columnheaderMapIndex']['item_num'] == 0 ? this.autoMappingData['columnheaderMapIndex']['item_num']+'':this.autoMappingData['columnheaderMapIndex']['item_num'] == null?'':this.autoMappingData['columnheaderMapIndex']['item_num'];
      
      let quantityCheck = this.autoMappingData['columnheaderMapIndex']['quantity'] == 0 ? this.autoMappingData['columnheaderMapIndex']['quantity']+'':this.autoMappingData['columnheaderMapIndex']['quantity'] == null?'':this.autoMappingData['columnheaderMapIndex']['quantity'];

      if(itemNumberCheck && quantityCheck != ''){
        for(let lbleIndx in this.mainRowArrayObj['labelsArray']){
          if(this.mainRowArrayObj['labelsArray'][lbleIndx]['labelName'] =='Item Number'){
            if(itemNumberCheck != '' && itemNumberCheck != $('#columnMap_'+lbleIndx).val()){
              this.commonService.showtoast('Please map correct value to Item Number column','warning');
              return false;
            }
          }else if(this.mainRowArrayObj['labelsArray'][lbleIndx]['labelName'] =='Quantity'){
            if(quantityCheck !='' && quantityCheck != $('#columnMap_'+lbleIndx).val()){
              this.commonService.showtoast('Please map correct value to Quantity column','warning');
              return false;
            }
          }
        }
      }else{
        if(this.autoMappingData['columnheaderMapIndex']['item_num'] == null){
          const idx: number = this.mainRowArrayObj['labelsArray'].findIndex((label: any) => label.labelName === 'Item Number');
          if(this.mainRowArrayObj['labelsArray'][idx]['mainlabelData'] == '' && this.mainRowArrayObj['labelsArray'][idx]['selectedName1'] == ''){
            this.commonService.showtoast('Item Number column is missing in the uploaded BOM file. Please re-uploud new BOM with all mandatory columns.','warning');
            return false;
          }
        }else{
          let msggs = '';
          if(!itemNumberCheck && !quantityCheck){
            msggs = 'Item Number and Quantity columns';
          }else if(!itemNumberCheck){
            msggs = 'Item Number column';
          }else if(!quantityCheck){
            msggs = 'Quantity column';
          }
          this.commonService.showtoast(msggs +' is missing in the uploaded BOM file. Please re-uploud new BOM with all mandatory columns.','warning');
          return false;
        }
      }
      this.commonService.commonMainObj.bomProcessData['bom_id'] = null
      this.commonService.commonMainObj.bomProcessData['user_id'] = this.commonService.commonMainObj.userData.userId?this.commonService.commonMainObj.userData.userId:null;
      this.commonService.commonMainObj.bomProcessData['project_id'] = this.commonService.commonMainObj.fileUploadedData['projectId'];
      this.commonService.commonMainObj.bomProcessData['row_mapping'] = {
        "header": this.commonService.commonMainObj.bomProcessXlData['headerRowNumber'],
        "data": this.commonService.commonMainObj.bomProcessXlData['dataRowNumber'],
        "lines": this.commonService.commonMainObj.bomProcessXlData['numberOfDataLineItems']
      };
      var labelsObj:any = {}
      for(var labelIdx in this.mainRowArrayObj['labelsArray']){
        labelsObj[this.mainRowArrayObj['labelsArray'][labelIdx]['mainLabelName']] = parseInt(this.mainRowArrayObj['labelsArray'][labelIdx]['selectedName1'])
      }
      this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex'] = labelsObj;
      this.commonService.commonMainObj.bomProcessData['column_mapping'] = {
        "description": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['description'],
        "do_not_install": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['do_not_install'],
        "footprint": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['footprint'],
        "item_num": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['item_num'],
        "mpn": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['manufacturer_part_number'],
        "quantity": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['quantity'],
        "ref_designators": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['reference_designators'],
        "tolerance": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['tolerance'],
        "value": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['value'],
        "vendor": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['vendor'],
        "vpn": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['vendor_part_number'],
        "manufacturer" : this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['manufacturer']
      },
      // this.commonService.commonMainObj.bomProcessData['column_mapping'] = this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex'];
      this.commonService.commonMainObj.bomProcessData['bom_properties']['bom_name'] = this.commonService.commonMainObj.uploadedFileFullPath
      this.commonService.commonMainObj.bomProcessData['file']['filename'] = this.commonService.commonMainObj.uploadedFileFullPath
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['name'] = this.commonService.commonMainObj.uploadedFile.name
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'] = [];
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'].push(this.commonService.commonMainObj.bomProcessXlData['rowHeaderData']);
      var newArray = this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'].concat(this.commonService.commonMainObj.bomProcessXlData['dataRowsList'])
      this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'] = newArray
      // this.commonService.commonMainObj.qtyAssemblies = $('#assembly_quantity').val ; 
      let mindex=0;
      for(let cma of this.mainRowArrayObj['labelsArray']){
          if(cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'){
            mindex++;
            continue;
          }else if(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number'){
            this.mappingArray.push(cma.labelName);
            this.selectedColMapValList.push($('#columnMap_'+mindex).val())
            mindex++;
          }else if(!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')){
            this.mappingArray.push(cma.labelName);
            this.selectedColMapValList.push($('#columnMap_'+mindex).val())
            mindex++;
          }
          
      }

      for(let i=0; i<this.selectedColMapValList.length;i++){
        for(let crow of this.mainRowArrayObj['bomOneMapArrayData']){
         
          if(this.selectedColMapValList[i] == crow.selectedObj){
            this.mapValueArray.push(crow.labelValue);
          }
        }
      }

      // console.log("mappingArray",this.mappingArray);
      // console.log("selectedColMapValList",this.selectedColMapValList)
      // console.log("this.mapValueArray",this.mapValueArray)
      this.bomMappingKeyObj = Object.fromEntries(this.mappingArray.map((key:any, index:any) => [key, this.mapValueArray[index]]));
      var bomColMappingObj ={
        "mapping":this.bomMappingKeyObj
      }
      this.apiService.updateDetailsToDashboard(this.flowActivityId,bomColMappingObj,'BOMColumnPage').subscribe((resDatas)=>{
      },err=>{
        console.log(err)
        });
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        setTimeout(()=>{
          this.commonService.sessionPortalLoad();
            this.commonService.loadingHide();
            this.apiService.checkUserSessionApi().subscribe((data: any)=>{
              if(data.status == 1){
                // this.router.navigateByUrl('/bomAssemblyProcess');
                this.router.navigateByUrl('/bomPreProcess');
                this.modalService.dismissAll('Save click');
              }
            },error =>{
              console.log('Error in checking user session', error);   
            })
        },1000);
      }else{
        // this.router.navigateByUrl('/bomAssemblyProcess');
        this.router.navigateByUrl('/bomPreProcess');
        this.modalService.dismissAll('Save click');
      }
    }
  }
  
  bomAutoMapScreen(screenCntnt:any){
    this.bomAutoMapScreenRendered = true;
    this.commonService.formattingCurrentDateTime();
    var bomAutoMapObj={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,bomAutoMapObj,'BOMColumnPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
      });
    this.modalService.open(screenCntnt, {ariaLabelledBy: 'modal-basic-title',windowClass:'modalPopUpAutoMap'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;  
    }, (reason) => {
      // console.log(reason);
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  // bomProceed(content:any){
  //   if(!this.commonService.commonMainObj.selectedFabTurntime || this.commonService.commonMainObj.selectedFabTurntime == ''){
  //     this.commonService.showtoast('Please select a PCB price to proceed','warning');
  //     return false;
  //   }
  //   if(this.commonService.commonMainObj.userSessionMemberId != null){
  //     this.commonService.sessionPortalLoad();
  //     setTimeout(()=>{
  //       this.apiService.checkUserSessionApi().subscribe((data: any)=>{
  //         if(data.status == 1){
  //           this.bomProceedSessionChecked(content);
  //         }
  //       },error =>{
  //         console.log('Error in checking user session', error);   
  //       })
  //     },800);
  //   }else{
  //     this.bomProceedSessionChecked(content);
  //   }
    
  // }

  bomProceed(content:any){
    this.commonService.sessionPortalLoad();
    if(!this.commonService.commonMainObj.selectedFabTurntime || this.commonService.commonMainObj.selectedFabTurntime == ''){
      this.commonService.showtoast('Please select a PCB price to proceed','warning');
      return false;
    }
    if(!this.commonService.commonMainObj.selectedFabTurntime || this.commonService.commonMainObj.selectedFabTurntime == ''){
      this.commonService.showtoast('Please select a PCB price to proceed','warning');
      return false;
    }
    var bomFile = this.commonService.commonMainObj.uploadedFile;
    var sideAssm1 = document.getElementById("numberOfSidesOne");
    var sideAssmFinal1:any = sideAssm1?.className.indexOf('active');
    this.commonService.commonMainObj.assemblySides = sideAssmFinal1 > 0 ? '1 side' : '2 sides' ;
    // var viaInPad = document.getElementById("viaInPadsYes");
    // var viaInFinPad:any = viaInPad?.className.indexOf('active');
    this.commonService.commonMainObj.leadFreeProcessing = $('#leadFreeYes').hasClass('active') ? 'Yes': 'No';
    if(this.commonService.commonMainObj.pcbType == 'Web PCB'){
      // this.commonService.commonMainObj.viaInPadData = $('#viaInPadsYes').hasClass('active') ? 'Yes': 'No';
      this.commonService.commonMainObj.viaInPadData = this.commonService.commonMainObj.boardDetailsDataObj.thruHoleViainPad;
    }else{
      this.commonService.commonMainObj.viaInPadData = 'No';
    }
    // this.commonService.commonMainObj.viaInPadData = 'No' ;
    if(this.bomUploadSec == true){
      // if(Object.keys(bomFile).length === 0){
      //   alert("Please upload a BOM file");
      // }
      // if($("input[name='numberOfSides']:checked").val() == ''){
      //   alert("Please select Number of sides to be assembled")
      // }
      if(!this.commonService.commonMainObj.fileUploadedData.uploadedBOM && !this.commonService.commonMainObj.uploadedFile){
        this.commonService.alertCall('Alert!!','Please upload a BOM file');
        return;
      }
      if (!this.IsAllowedFileExtension && !this.commonService.commonMainObj.fileUploadedData.uploadedBOM && !this.commonService.commonMainObj.uploadedFile){
        this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
        return;
      }
      if(!this.commonService.commonMainObj.manuallyBomUploded && Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0].indexOf('csv')>=0){
        this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
        return;
      }
      if(this.commonService.commonMainObj.additionalTextEnig || this.commonService.commonMainObj.additionalTextHasl){
        $("#leadFreeAdditionalMessage").trigger('click');
        this.modalName = content;
      }else{
        this.proceedAfterLeadfreeMessage(content)
      }
      
      
    }else{
      // console.log("this.selectedFabTurntimeVal ",this.selectedFabTurntimeVal );
      this.finalQuotedataObj ={
        "pcbQuantity": this.commonService.commonMainObj.selectedFabQuantity,
        "pcbTurntime": this.selectedFabTurntimeVal 
      }
      this.commonService.loadingShow();
      this.apiService.createPcbFinalQuote(this.finalQuotedataObj).subscribe((finalQuateResData:any) => {
        this.commonService.sessionPortalLoad();
        this.commonService.loadingHide();
          if(finalQuateResData){
            var pricingBomObj={
              "assemblyAdded": $('#assemblyYes').hasClass('active') ? 'Yes':'No',
            }
            this.apiService.updateDetailsToDashboard(this.flowActivityId,pricingBomObj,'PCBFabPricingPage').subscribe((resDatas)=>{
              // console.log("updateDetailsToDashboard",resDatails);
            });
            if(this.commonService.commonMainObj.userSessionMemberId){
              this.apiService.checkUserSessionApi().subscribe((data: any)=>{
                if(data.status == 1){
                  this.commonService.commonMainObj.pcbFinalQuotedata = finalQuateResData;
                  // console.log("this.commonService.commonMainObj.pcbFinalQuotedata",this.commonService.commonMainObj.pcbFinalQuotedata);
                  this.router.navigateByUrl('/quoteDetails');
                }
              },error =>{
                console.log('Error in checking user session', error);
              })
            }else{
              this.commonService.commonMainObj.pcbFinalQuotedata = finalQuateResData;
              // console.log("this.commonService.commonMainObj.pcbFinalQuotedata",this.commonService.commonMainObj.pcbFinalQuotedata);
              this.router.navigateByUrl('/quoteDetails');
            }
          }
      },error => {
        this.commonService.loadingHide();
      });
    }
  }

  proceedAfterLeadfreeMessage(content:any){
    if(this.commonService.commonMainObj.fileUploadedData.uploadedBOM && this.commonService.commonMainObj.autoUploadFileName){
        this.commonService.loadingShow();
        this.apiService.getAutoUploadBOMFile(Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0],"xlFileData").subscribe((data: any)=>{
          this.commonService.commonMainObj.uploadedFile = data;
          this.commonService.commonMainObj.uploadedFile['name'] = Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0];
          this.bomAutoMapData(data.body,content);
          // const formData = new FormData();
          // formData.append("file", data.body);
          // this.httpClient.post<any>('https://customerstagingbackend.app.protoexpress.com/automap', formData).subscribe(
          //   (res) => console.log('sdkfnsd',res),
          //   (err) => console.log(err)
          // );
        }, (error: any)=>{
          this.commonService.loadingHide();
        });
      }else{
        this.commonService.loadingShow();
        this.bomAutoMapData(this.commonService.commonMainObj.uploadedFile,content);
      }
  }

  // bomAutoMapData(bomFile:any,content:any){
  //   if(this.commonService.commonMainObj.userSessionMemberId != null){
  //     this.commonService.sessionPortalLoad();
  //     setTimeout(()=>{
  //       this.apiService.checkUserSessionApi().subscribe((data: any)=>{
  //         if(data.status == 1){
  //           this.bomAutoMapDataSessionChecked(bomFile,content);
  //         }
  //       },error =>{
  //         console.log('Error in checking user session', error);   
  //       })    
  //     },800);
  //   }else{
  //     this.bomAutoMapDataSessionChecked(bomFile,content);
  //   }
  // }

  bomAutoMapData(bomFile:any,content:any){
    this.commonService.sessionPortalLoad();
    this.bomFileData = bomFile;
    this.commonService.commonMainObj.bomFileData = bomFile;
    this.selectedSheetNum = '';
    this.commonService.commonMainObj.customS3BomId='';
    this.apiService.assemblyBomSheetsProcees(bomFile).subscribe((sheetsData:any) => {
      console.log("sheetsData",sheetsData);
      if(sheetsData.message != '' && sheetsData.message != undefined){
        this.commonService.loadingHide();
        this.commonService.alertCall('Error',sheetsData.message);
        return;
      } 
    this.commonService.commonMainObj.customS3BomId = sheetsData[0].uploadedFileName;
    var pricingBomObj={
      "assemblyAdded": $('#assemblyYes').hasClass('active') ? 'Yes':'No',
      "BomName":{
        "fromDesignFile":this.checkBomAutoUploaded,
        "added": this.checkBomAutoUploaded == '' ? this.commonService.commonMainObj.uploadedFile?.name+'|'+this.commonService.commonMainObj.customS3BomId  :'',
        "changed":this.bomChanged == true ? this.commonService.commonMainObj.uploadedFile?.name+'|'+this.commonService.commonMainObj.customS3BomId  : ''
      }
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,pricingBomObj,'PCBFabPricingPage').subscribe((resDatas)=>{
      // console.log("updateDetailsToDashboard",resDatails);
      });
      if(this.commonService.commonMainObj.userSessionMemberId != null){
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            if(data.status == 1){
              this.sheetsArray = [];
              this.showNumberOfSheets = true;
              for(var sheetIndx in sheetsData){
                this.sheetsArray.push(sheetsData[sheetIndx])
              }
              if(this.sheetsArray.length == 1){
                // this.showNumberOfSheets = true;
                this.selectedSheetNum = '0';
                this.bomFinalMapData('',content)
                //this.bomAutoMapScreen(content);
                setTimeout(()=>{        
                  this.commonService.loadingHide();
                },1000);
              }else{
                this.showNumberOfSheets = false;
                this.bomAutoMapScreen(content);       
                this.commonService.loadingHide();
              }
            }
          },error =>{
            console.log('Error in checking user session', error);   
          })
      }else{
        this.sheetsArray = [];
        this.showNumberOfSheets = true;
        for(var sheetIndx in sheetsData){
          this.sheetsArray.push(sheetsData[sheetIndx])
        }
        if(this.sheetsArray.length == 1){
          this.selectedSheetNum = '0';
          this.bomFinalMapData('',content)
          //this.bomAutoMapScreen(content);
          setTimeout(()=>{        
            this.commonService.loadingHide();
          },1000);
        }else{
          this.showNumberOfSheets = false;
          this.bomAutoMapScreen(content);       
          this.commonService.loadingHide();
        }
      }
    },error => {
      this.commonService.loadingHide();
      console.log(error);
    })
    // this.bomFinalMapData(bomFile,content)
  }

  proceedSheet(){
    this.commonService.sessionPortalLoad();
    if(this.selectedSheetNum){
      this.bomFinalMapData('','')
    }else{
      this.commonService.alertCall('Warning!','Please select sheet');
    }
  }

  bomFinalMapData(bomFile:any,content:any){
    this.apiService.assemblyBomProcees(this.bomFileData,this.selectedSheetNum).subscribe((data:any) => {
      this.commonService.loadingHide();
      if(data.error){
        setTimeout(() => {
          this.commonService.alertCall('Warning!',data.error);
          return false;
        },800);
      }else{
        if(content){
          this.bomAutoMapScreen(content);
        }
      }
      this.autoMappingData = '';
      this.mainRowArrayObj = {
        'labelsArray' : [],
        'bomOneMapArrayData' : []
      };
      data['columnheaderMapIndex']['item_num']= data['columnheaderMapIndex']['item_num'] || data['columnheaderMapIndex']['item_num'] == 0?data['columnheaderMapIndex']['item_num']:null;
      data['columnheaderMapIndex']['manufacturer_part_number']= data['columnheaderMapIndex']['manufacturer_part_number'] || data['columnheaderMapIndex']['manufacturer_part_number'] == 0?data['columnheaderMapIndex']['manufacturer_part_number']:null;
      data['columnheaderMapIndex']['reference_designators']= data['columnheaderMapIndex']['reference_designators'] || data['columnheaderMapIndex']['reference_designators'] == 0?data['columnheaderMapIndex']['reference_designators']:null;
      data['columnheaderMapIndex']['quantity']= data['columnheaderMapIndex']['quantity'] || data['columnheaderMapIndex']['quantity'] == 0?data['columnheaderMapIndex']['quantity']:null;
      this.autoMappingData = data;
      this.commonService.commonMainObj.autoMappingHeaderData = this.autoMappingData['rowHeaderBOMData'];
      this.commonService.commonMainObj.bomProcessXlData = data;
      for(let dataIndex in this.autoMappingData['columnheaderMapIndex']){
        let displayName:any = dataIndex == 'item_num'?'Item Number':dataIndex == 'quantity'?'Quantity':dataIndex == 'reference_designators'?'Reference designator': dataIndex == 'manufacturer_part_number'?'MPN': dataIndex == 'manufacturer'?'Manufacturer':dataIndex == 'description'?'Description':dataIndex == 'value' ? 'Value':dataIndex == 'do-not-install'?'DNI':dataIndex == 'vendor_part_number'?'Part Number':dataIndex == 'footprint'?'Footprint':dataIndex;
          let labelObj = {
            'labelName' : displayName,
            'labelType':'existing',
            'selectedName1' : this.autoMappingData['columnheaderMapIndex'][dataIndex] != null ?parseInt(this.autoMappingData['columnheaderMapIndex'][dataIndex]):'',
            'mainlabelData': this.autoMappingData['columnheaderMapIndex'][dataIndex] != null ?parseInt(this.autoMappingData['columnheaderMapIndex'][dataIndex]):'',
            'mainLabelName' : dataIndex
          }
          this.mainRowArrayObj['labelsArray'].push(labelObj);
          if(dataIndex == 'manufacturer_part_number'){
            this.commonService.commonMainObj.mpnIndex = this.autoMappingData['columnheaderMapIndex'].manufacturer_part_number;
          }
          if(dataIndex == 'quantity'){
            this.commonService.commonMainObj.qtyIndex = this.autoMappingData['columnheaderMapIndex'].quantity;
          }
          if(dataIndex == 'reference_designators'){
            this.commonService.commonMainObj.refDesignatorIndex = this.autoMappingData['columnheaderMapIndex'].reference_designators;
          }
          if(dataIndex == 'vendor_part_number'){
            this.commonService.commonMainObj.partNumberIndex = this.autoMappingData['columnheaderMapIndex'].vendor_part_number;
          }
          if(dataIndex == 'manufacturer'){
            this.commonService.commonMainObj.maufacturerIndex = this.autoMappingData['columnheaderMapIndex'].manufacturer;
          }
      }
      for(let bomDataIndex in this.autoMappingData['rowHeaderBOMData']){
        let dropDownDataObj = {
          'labelValue' : this.autoMappingData['rowHeaderBOMData'][bomDataIndex],
          'labelIndx' : bomDataIndex,
          'selectedObj' : bomDataIndex
        }
        this.mainRowArrayObj['bomOneMapArrayData'].push(dropDownDataObj);
        // console.log("this.mainRowArrayObj['labelsArray']",this.mainRowArrayObj['labelsArray']);
        // console.log("this.mainRowArrayObj['bomOneMapArrayData']",this.mainRowArrayObj['bomOneMapArrayData']);
      }
      this.showNumberOfSheets = true;
      setTimeout(() => {
        this.checkIfAllOptionsPresent();
      }, 500);
      // this.bomAutoMapScreen(content);


    },error => {
      if(error.status == 400){
        this.commonService.showtoast(error.error.error,'warning');
      }
      this.commonService.loadingHide();
      console.log(error);
    })
  }

  checkIfAllOptionsPresent(){
    var allValuesSelected = true;
    // if($('#columnMap_1').val() == '' || $('#columnMap_2').val() == '' || $('#columnMap_3').val() == '' || $('#columnMap_4').val() == ''){
    //   allValuesSelected = false;
    //   return false;
    // }
    $('.header-mapping-dropdown').each(function() {
      //Changes done based on OFP-652
      // if ($(this).val() == '') {
      if ($(this).val() == '' && $(this).hasClass('requiredField')) {
        allValuesSelected = false;
        return false;
      }
    });
    if (allValuesSelected) {
      this.disableAutomapProceed = false;
    }else{
      this.disableAutomapProceed = true;
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  checkPrice(turntime:any,quantity:any,price:any,){
    this.commonService.commonMainObj.selectedFabTurntime  = turntime;
    this.commonService.commonMainObj.selectedFabQuantity  = quantity;
    this.commonService.commonMainObj.selectedFabOrgTurntime = turntime;
    this.selectedFabPrice  = price;
    this.commonService.commonMainObj.selectedFabPrice  = price;
    $('#assemblyYes').prop("disabled",false);
    $('#quote-proceed-btn').prop("disabled",false);
    if(this.commonService.commonMainObj.selectedFabTurntime.includes("Days")){
      this.selectedFabTurntimeVal = this.commonService.commonMainObj.selectedFabTurntime.replace("Days", "");
    }else if(this.commonService.commonMainObj.selectedFabTurntime.includes("Day")){
      this.selectedFabTurntimeVal =  this.commonService.commonMainObj.selectedFabTurntime.replace("Day", "");
    }else if(this.commonService.commonMainObj.selectedFabTurntime.includes("Weeks")){
      this.selectedFabTurntimeVal =  this.commonService.commonMainObj.selectedFabTurntime.replace("Weeks", "");
      this.selectedFabTurntimeVal =this.selectedFabTurntimeVal*5;
    }else if(this.commonService.commonMainObj.selectedFabTurntime.includes("Week")){
      this.selectedFabTurntimeVal =   this.commonService.commonMainObj.selectedFabTurntime.replace("Week", "");
      this.selectedFabTurntimeVal =this.selectedFabTurntimeVal*5;
    }else{
      this.selectedFabTurntimeVal = this.commonService.commonMainObj.selectedFabTurntime;
    }
    this.commonService.commonMainObj.selectedFabTurntimeVal = this.selectedFabTurntimeVal
    let viaInPadToolTips =[
      {name:'1',value:'You have chosen a PCB fabrication time of '+this.selectedFabTurntimeVal+' days.In order to <span style="color: green;">fill your via-in-pads with non-conductive fill,</span> we will need PCB fabrication cycle of 5 days or more.Kindly choose a turn time for 5 days or more in the PCB price matrix above.'},
    ];
    if(this.selectedFabTurntimeVal < 5 && this.bomUploadSec == true && this.commonService.commonMainObj.boardDetailsDataObj.thruHoleViainPad == 'Yes' && this.commonService.commonMainObj.pcbType == 'Web PCB'){
      $('.select-price').prop('checked', false);
      Swal.fire({
          title: "Alert!!",
          html: 'You have chosen a PCB fabrication time of '+ this.selectedFabTurntimeVal +'days.In order to fill your via-in-pads with non-conductive fill, we will need PCB fabrication cycle of 5 days or more. Kindly choose a turn time for 5 days or more in the PCB price matrix. <br>If you want to change the value of PCB has Via-in-pad features?, please click on ‘Back’ button and change the value on the ‘Board Details’ page',
          width: '35em'
      });
      return;
    }
    // if(this.selectedFabTurntimeVal < 5){
      // $('#viaInPadsYes').prop("disabled",true);
      // $('#viaInPadsNo').addClass('btn-green');
      // $('#viaInPadsNo').addClass('active');
      // $('#viaInPadsNo').removeClass('btn-gray');
      // $('#viaInPadsYes').removeClass('btn-green');
      // $('#viaInPadsYes').removeClass('active');
      // $('#viaInPadsYes').addClass('btn-gray');
      // $('#viaInPadInfo').html(viaInPadToolTips[0].value);
      // $('#viaInPadInfo').removeClass('chk-vis');
    // }else{
    //   $('#viaInPadsYes').prop("disabled",false);
    //   $('#viaInPadInfo').html('');
    //   var v = $('#viaInPadInfo').text();
    //   if (v.trim() === "") {
    //     $('#viaInPadInfo').addClass('chk-vis');
    //   }else{
    //     $('#viaInPadInfo').removeClass('chk-vis');
    //   }
    // }
    // this.commonService.commonMainObj.viaInPadSelected = $('#viaInPadsYes').hasClass('active')?'Yes':"No";
    this.commonService.commonMainObj.viaInPadSelected = this.commonService.commonMainObj.boardDetailsDataObj.thruHoleViainPad;
    var boardQty = parseInt(this.commonService.commonMainObj.selectedFabQuantity)
    this.qtyIndvBoardsArray = [];
    if(this.commonService.commonMainObj.pcbType != 'Web PCB'){
      this.qtyIndvBoardsArray.push(boardQty);
    }else{
      for(var i=0; i<boardQty; i++){
        this.qtyIndvBoardsArray.push(i+1);
      }
    }
    this.qtyIndvBoardsArray.reverse();
    this.commonService.commonMainObj.qtyAssemblies = this.qtyIndvBoardsArray[0];

  }
  checkAssemblyPrice(turntime:any,quantity:any,price:any){
    this.commonService.commonMainObj.selectedAssemblyTurntime  = turntime;
    this.commonService.commonMainObj.selectedAssemblyQuantity  = quantity;
    this.commonService.commonMainObj.selectedAssemblyPrice  = price;
    if(turntime < 7 && this.commonService.commonMainObj.viaInPadSelected == 'Yes'){
      this.isHidden = false;
    }
    $('#assembly-quote-proceed-btn').prop("disabled",false);
  }
  changeItarToSwitchButtons(event:any){
    if(event.target.checked){
      $('#itarRadioButtonGroup').css('display','none');
      $('#itarSwitchButtonGroup').css('display','block');

      if(event.target.id == 'itarYes'){
        this.commonService.commonMainObj.itar  = "Yes"
        $('#itarYes').addClass('btn-green');
        $('#itarYes').addClass('active');
        $('#itarYes').removeClass('btn-gray');
        $('#itarNo').removeClass('btn-green');
        $('#itarNo').addClass('btn-gray');
        $('#itarNo').removeClass('active');
      }else if(event.target.id == 'itarNo'){
        this.commonService.commonMainObj.itar  = "No"
        $('#itarNo').addClass('btn-green');
        $('#itarNo').addClass('active');
        $('#itarNo').removeClass('btn-gray');
        $('#itarYes').removeClass('btn-green');
        $('#itarYes').removeClass('active');
        $('#itarYes').addClass('btn-gray');
      }
    }else{
      $('#itarRadioButtonGroup').css('display','block');
      $('#itarSwitchButtonGroup').css('display','none');

    }
  }

  // navigateToQuoteDetails(){
  //   this.router.navigateByUrl('/quoteDetails');
  // }
  navigateToCustomeQuote(turntime:any,quantity:any,leadFreeExtracted:any){
    this.commonService.commonMainObj.selectedFabTurntime  = turntime;
    this.commonService.commonMainObj.selectedFabQuantity  = quantity;
    // this.commonService.commonMainObj.quoteDetailList.pcbTurnTime = turntime
    if(this.commonService.commonMainObj.selectedFabTurntime.includes("Days")){
      this.selectedFabTurntimeVal = this.commonService.commonMainObj.selectedFabTurntime.replace("Days", "");
    }else if(this.commonService.commonMainObj.selectedFabTurntime.includes("Day")){
      this.selectedFabTurntimeVal =  this.commonService.commonMainObj.selectedFabTurntime.replace("Day", "");
    }else if(this.commonService.commonMainObj.selectedFabTurntime.includes("Weeks")){
      this.selectedFabTurntimeVal =  this.commonService.commonMainObj.selectedFabTurntime.replace("Weeks", "");
      this.selectedFabTurntimeVal =this.selectedFabTurntimeVal*5;
    }else if(this.commonService.commonMainObj.selectedFabTurntime.includes("Week")){
      this.selectedFabTurntimeVal =   this.commonService.commonMainObj.selectedFabTurntime.replace("Week", "");
      this.selectedFabTurntimeVal =this.selectedFabTurntimeVal*5;
    }else{
      this.selectedFabTurntimeVal = this.commonService.commonMainObj.selectedFabTurntime;
    }
    this.commonService.commonMainObj.selectedFabTurntimeVal = this.selectedFabTurntimeVal
    this.commonService.commonMainObj.pcbType = "Custom/Advanced PCB";

    // this.commonService.commonMainObj.customQuoteParam = pebResData.customQuoteParameters;
    this.commonService.commonMainObj.noPriceForTurntimeQtyCombination = true;
    if(leadFreeExtracted == true){
      this.modalService.dismissAll();
      //update dashboard
      var extractedDataObj={
        "leadFreeExtracteddata":{
          "Lead Free Processing":this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance == 'RoHS/Lead Free'?'Yes':'No',
          "Surface Finish":this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish
        }
      }
      this.apiService.updateDetailsToDashboard(this.flowActivityId,extractedDataObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas:any)=>{
      // this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId; 
      })
    }
    this.router.navigateByUrl('/quoteDetails');
  }

  backToBoardDetails(){
    var pcbBackToBoardPageObj={
      "returnedToBoardDetailsPage" : "Yes"
    }
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
    }
    this.commonService.commonMainObj.backToBoardDetails = true; 
    this.commonService.commonMainObj.selectedFabTurntime = '';  
    this.apiService.updateDetailsToDashboard(this.flowActivityId,pcbBackToBoardPageObj,'PCBFabPricingPage').subscribe((resDatas:any)=>{
      console.log("pcbBackToBoardPageObj",resDatas);
      this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId;
      });
    setTimeout(() => {
      this.router.navigateByUrl('/boardDetails');
    }, 2000);  
  }

  assemblyErrorsCheck(){
    if(Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length > 0){
      this.commonService.commonMainObj.uploadedFilesData['fileAsmblyErrors'] = []
      for(var errIndx in this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']){
        this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'][errIndx]['errorCode'] = errIndx;
        this.commonService.commonMainObj.uploadedFilesData['fileAsmblyErrors'].push(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'][errIndx]);
      }
      console.log("errorrrr", this.commonService.commonMainObj.uploadedFilesData['fileAsmblyErrors'])
    }
  }
  checkAssemblyErrorModal(content:any){
    this.assemblyErrorsCheck();
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "fileErrors-assembly"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      //console.log("Modal close with reason");
      this.missingFiles = [];
      this.missingListFiles = [];
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      //console.log("Modal close with out reason");
      this.missingFiles = [];
      this.missingListFiles = [];
    });
    this.disableAssemblyErrorProceed = true;
  }
  
  missingFilesHandel(event:any, Id:any){
    console.log("missinfFiles", event.target.files);
    var uploadedFile = event.target.files[0];
    var uploadedFileName = event.target.files[0].name;
    var base64File : any;
    var base64Data:any;
    this.missingFiles[Id] = [];
    if(uploadedFileName.split(".").pop() == "zip" || uploadedFileName.split(".").pop() == "rar"){
      $('#'+Id+'_error').text("Zipped files are not allowed, please upload the missing individual file");
      return false;
    }else{
      $('#'+Id+'_error').text('');
      $('#'+Id+'_name').text(uploadedFileName);
      $('#'+Id+'_delete').show();
      $('#'+Id).parent().hide();
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(uploadedFile);
      reader.onload = () => {
        base64File = reader.result;
      };
      setTimeout(() => {
        if(base64File){
          base64Data = base64File.toString().split('base64,')[1]
        }
      }, 100);
      this.missingFiles[Id]={}
      this.missingFiles[Id]['errCode'] = Id;
      this.missingFiles[Id]['fileName'] = uploadedFileName;
      setTimeout(() => {
        this.missingFiles[Id]['file'] = base64Data;
      }, 200);
    }
    setTimeout(() => {
      this.missingListFiles.push(this.missingFiles[Id]);
      if(Object.keys(this.missingFiles).length == Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length){
        this.disableAssemblyErrorProceed = false;
      }
    }, 500);
    
    console.log(this.missingListFiles);
  }
  deleteFile(Id:any){
    $('#'+Id+'_name').text('');
    $('#'+Id+'_delete').hide();
    delete this.missingFiles[Id];
    $('#'+Id).parent().show();
    $('#'+Id).val('');
    for(let i = 0; i<this.missingListFiles.length ; i++){
      if(this.missingListFiles[i].errCode == Id){
        this.missingListFiles.splice(i, 1);
      }
    }
    if(Object.keys(this.missingFiles).length == Object.keys(this.commonService.commonMainObj.uploadedFilesData['assemblyErrors']).length){
      this.disableAssemblyErrorProceed = false;
    }else{
      this.disableAssemblyErrorProceed = true;
    }
    
    //console.log(this.missingFiles);
    //console.log(this.missingListFiles);
  }
  close() {
    this.modalService.dismissAll();
  }
  reValidate(){
    if(this.commonService.commonMainObj.saveMataDataCheck == false){
      if(!this.socketDataLoadingCheck){
        this.socketDataLoadingCheck = true;
        this.commonService.loadingShow();
      }
      this.reValidateWithMataData();
      return false;
    }else{
      this.commonService.loadingHide();
    }
    var dataObj:any = {};
    for(let i=0; i< this.missingListFiles.length; i++){
      var fileCount = Number(i)+1;
      dataObj['file'+fileCount] = {
        'file':this.missingListFiles[i].file,
        'fileName':this.missingListFiles[i].fileName,
        'errorCode': this.missingListFiles[i].errCode
      }
    }
    console.log("OBJECT",dataObj );
    // var testData = {
    //   "file1":{
    //     "file": "",
    //     "fileName":"",
    //     "errorCode":"",
    //   }
    // }
    var dataFile = JSON.stringify(dataObj);
    var formData = new FormData();
    formData.append('data',dataFile);
    formData.append('s3ZipFileName', this.commonService.commonMainObj.s3FileName);
    formData.append('reValidate', "True");
    console.log("formdata",formData );
    this.apiService.reValidateMissingFiles(formData).subscribe((data: any)=>{
      this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'] = [];
      this.commonService.commonMainObj.uploadedFilesData['fileAsmblyErrors'] = [];
      this.commonService.commonMainObj.s3FileName = data.s3_file;
      if(Object.keys(data['assemblyErrors']).length == 0){
        this.assemblyYesCheck();
        this.close();
      }
      if(Object.keys(data['assemblyErrors']).length > 0){
        this.commonService.commonMainObj.uploadedFilesData['assemblyErrors'] = data['assemblyErrors'];
        this.assemblyErrorsCheck();
        this.disableAssemblyErrorProceed = true;
      }
      if((!data['assemblyErrors'].hasOwnProperty("FV_BM_E01") || !data['assemblyErrors'].hasOwnProperty("FV_BM_E00"))  && (this.missingFiles.hasOwnProperty("FV_BM_E01") || this.missingFiles.hasOwnProperty("FV_BM_E00"))){
        this.commonService.commonMainObj.autoUploadFileName = Object.values(data.uploadedBOM)[0];
        this.commonService.commonMainObj.fileUploadedData.uploadedBOM = data.uploadedBOM;
        //console.log("BOM AUTO UPLODED CHECK");
      }
      //console.log(data);
    });
  }
  reValidateWithMataData(){
    setTimeout(()=>{
      this.reValidate();
    },1500)
    
  }
  showLeadFreeToolTip(labelNum:any){
    $("#leadFreeProcess-"+labelNum).html(this.assemblyProcesstooltips[labelNum-1].value);
  }
  hideLeadFreeToolTip(labelValue:any){
    $("#leadFreeProcess-"+labelValue).html("");
  }
  openListOfPcbSpecification(content:any){
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  // showAssToolTip(text:any,index:any){
  //   $("#infoIcon-"+index).html(text);
  // }
  // hideAssToolTip(text:any,index:any){
  //   $("#infoIcon-"+index).html("");
  // }
  showToolTip(labelNum:any){
    $("#pcbFab-"+labelNum).html(this.pcbFabtooltips[labelNum-1].value);
  }
  hideToolTip(labelValue:any){
    $("#pcbFab-"+labelValue).html("");
  }

  showImageToolTip(imgType:any){
    if(imgType == "Default_icon"){
      $('.lableImageLabel-'+imgType).html("Default value");
    }else if(imgType == "Extracted_icon"){
      $('.lableImageLabel-'+imgType).html("Extracted from uploaded data file");
    }else if(imgType == "Updated_icon"){
      $('.lableImageLabel-'+imgType).html("User updated value");
    }
    
  }
  hideImageToolTip(imgType:any){
    $('.lableImageLabel-'+imgType).html("");
  }
  openLeadFreeAdditionalMessage(content:any){
    let modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true,backdrop: 'static',keyboard: false, windowClass : "custom-modal-window"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  continueWithOnlineQuote(){
    this.modalService.dismissAll();
    this.proceedAfterLeadfreeMessage(this.modalName);
    this.commonService.commonMainObj.istForLeadFree = true;
    this.commonService.commonMainObj.istDetailForLeadFree = this.commonService.commonMainObj.additionalTextEnig ? "This is an FYI to acknowledge the data updated by the customer. The value of Lead-free processing in the uploaded design file is Leaded. Note: Extracted from "+this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance_extracted_from+". However, to proceed with the online quote, 'Lead-free Processing' must be set to 'Yes' when the surface finish is 'ENIG'. The customer has confirmed acceptance to proceed with the online flow by setting 'Lead-free Processing' to 'Yes'.":this.commonService.commonMainObj.additionalTextHasl ? "This is an FYI to acknowledge the data updated by the customer. The value of Lead-free processing in the uploaded design file is RoHS/Lead Free. Note:extracted from "+this.commonService.commonMainObj.fileUploadedData.boardParam_assembly.rohs_compliance_extracted_from+". However, to proceed with the online quote, 'Lead-free Processing' must be set to 'No' when the surface finish is 'HASL'. The customer has confirmed acceptance to proceed with the online flow by setting 'Lead-free Processing' to 'No'.":''
  }
}
